<template>
  <div class="loader">
    <div class="spinner" />
  </div>
</template>

<script>
export default {
  name: 'Spinner',
}
</script>

<style scoped lang="scss">
.loader {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  .spinner {
    z-index: 100;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border-width: 0 0 2px 2px;
    border-color: #f57f17;
    border-style: solid;
    animation: spin 1s infinite linear;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
